// Staff/coach-facing accolades card on the athlete detail page.
// Coaches (perms.canVerify=false) see accolades read-only with a static blue
// seal on verified ones; staff/partners (canVerify=true) get a toggle seal.
import React from 'react';
import SealButton from './SealButton';
import useAccoladeVerify from './useAccoladeVerify';

const LEVEL_LABEL = {
  national: 'National', state: 'State', regional: 'Regional',
  conference: 'Conference', showcase: 'Showcase',
  club_selection: 'Club Selection', school: 'School / Team',
};
const TYPE_LABEL = {
  honor: 'Honor', ranking: 'Ranking',
  club_selection: 'Club Selection', certification: 'Certification',
};

export default function AccoladesCard({ userId, accolades, setAccolades, canVerify, apiUrl, getConfig }) {
  const { toggleVerify, busyId } = useAccoladeVerify({ userId, apiUrl, getConfig, setAccolades });
  if (!accolades || accolades.length === 0) return null;

  return (
    <div className="ae-card ae-card--pad">
      <div className="ae-card__head">
        <h3 className="ae-card__title">Accolades</h3>
        {canVerify && <span className="ae-card__hint">Click a seal to verify</span>}
      </div>
      <div className="ae-accolades">
        {accolades.map(a => (
          <div key={a.id} className="ae-accolade">
            <div className="ae-accolade__body">
              <div className="ae-accolade__title">{a.accolade_text}</div>
              <div className="ae-accolade__meta">
                {LEVEL_LABEL[a.level] && <span className="accolade-chip">{LEVEL_LABEL[a.level]}</span>}
                {a.accolade_type && a.accolade_type !== 'honor' && (
                  <span className="accolade-chip">{TYPE_LABEL[a.accolade_type] || a.accolade_type}</span>
                )}
                {a.issuing_body && <span className="ae-accolade__src">{a.issuing_body}</span>}
                {a.rating_value && <span className="ae-accolade__src">{a.rating_value}</span>}
                {a.year && <span className="ae-accolade__src">{a.year}</span>}
              </div>
            </div>
            {canVerify ? (
              <SealButton
                className="ae-accolade__seal"
                state={a.verified ? 'verified' : 'unverified'}
                title={a.verified ? 'Verified — click to unverify' : 'Not verified — click to verify'}
                disabled={busyId === a.id}
                onToggle={() => toggleVerify(a)}
              />
            ) : (
              a.verified && (
                <SealButton className="ae-accolade__seal" state="verified" title="Verified" disabled onToggle={() => {}} />
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
